/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Track object containing the vessel's route coordinates
 * @export
 * @interface TrackResultTrack
 */
export interface TrackResultTrack {
    /**
     * Array of coordinate pairs for the vessel's route
     * @type {Array<Array<number>>}
     * @memberof TrackResultTrack
     */
    coordinates?: Array<Array<number>>;
}

/**
 * Check if a given object implements the TrackResultTrack interface.
 */
export function instanceOfTrackResultTrack(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TrackResultTrackFromJSON(json: any): TrackResultTrack {
    return TrackResultTrackFromJSONTyped(json, false);
}

export function TrackResultTrackFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackResultTrack {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'coordinates': !exists(json, 'coordinates') ? undefined : json['coordinates'],
    };
}

export function TrackResultTrackToJSON(value?: TrackResultTrack | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'coordinates': value.coordinates,
    };
}

